import React from 'react';
import styled from 'styled-components';

import { Backdrop } from './Backdrop';

const DialogWindow = styled.div`
    position: fixed;
    width: 100%;

    max-width: ${(props) => props.maxWidth || '550px'};
    background: ${(props) => props.bg || props.theme.background};
    border-radius: 5px;
    transition: all 0.25s;
    pointer-events: none;
    overflow-x: ${(props) => props.overflowX || 'hidden'};

    &[open] {
        pointer-events: auto;
    }

    @media (min-width: ${(props) => props.theme.mobileLimit}) {
        max-height: ${(props) => props.maxHeight};

        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0);

        &[open] {
            transform: translate(-50%, -50%) scale(1);
        }
    }

    @media (max-width: ${(props) => props.theme.mobileLimit}) {
        top: 0;
        left: 0;
        height: 100%;
        transform: scale(0);
        max-width: none;
        border-radius: 0;

        &[open] {
            transform: scale(1);
        }
    }
`;

const Dialog = React.forwardRef(({ open, onClick, ...props }, ref) => {
    return (
        <Backdrop
            onClick={() => onClick && onClick()}
            open={open}
        >
            <DialogWindow ref={ref} open={open} {...props} />
        </Backdrop>
    );
});

export { Dialog };
